module.exports = __webpack_public_path__ + "media/images/icon-insta-a9610b02b38812c7feb90465117bcc7c.svg";